import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Filters = Partial<{
  material: string;
  materialDescription: string;
  batch: string;
  productReasonTypeId: string;
  totalValue: string;
  shelfLifeExpirationDate: string;
  storageLocation: string;
  destinationPlant: string;
}>;

type State = {
  filters: Filters;
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  clearState: () => void;
};

type Options = {
  persisted?: boolean;
}

const getInitialState = () => ({
  filters: {},
});

const PERSISTENCE_OPTIONS = {
  name: 'blocked-products-search-params-v1',
};

const store = create<State & Actions>(
  (set) => ({
    ...getInitialState(),
    updateFilters: (filters) => set({ filters }),
    clearState: () => set(getInitialState()),
  }),
);

const persistStore = create(
  persist<State & Actions>(
    (set) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      clearState: () => set(getInitialState()),
    }),
    PERSISTENCE_OPTIONS,
  ),
);

export const useBlockedProductsSearchParams = (options?: Options) => {
  return options?.persisted ? persistStore() : store();
};